// src/router/index.js
import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import LoginView from "../views/LoginView.vue";
import RegisterView from "@/views/RegisterView.vue";
import CmsView from "@/views/CmsView.vue";
import IndexView from "@/views/IndexView.vue";
import ProjectHomeView from "@/views/meetingware/ProjectHomeView.vue";
import ProjectMeetingView from "@/views/meetingware/ProjectMeetingView.vue";
import ProjectKanban from "@/views/meetingware/ProjectKanban.vue";
import ProjectPageView from "@/views/meetingware/ProjectPageView.vue";
import TestView from "@/views/TestView.vue";
import SprintsView from "@/views/meetingware/SprintsView.vue";
import MetricsView from "@/views/meetingware/MetricsView.vue";
import ChatView from "@/views/meetingware/ChatView.vue";
import TutorialView from "@/views/TutorialView.vue";
import NotfoundView from "@/views/NotfoundView.vue";
import ProjectLoginView from "@/views/meetingware/ProjectLoginView.vue";
import ProjectRegisterview from "@/views/meetingware/ProjectRegisterview.vue";


const routes = [
  {
    path: "/",
    name: "index",
    component: IndexView,
  },
  {
    path: '/test',
    name: 'Test',
    component: () => TestView
  },
  {
    path: "/home",
    name: "Home",
    component: HomeView,
  },
  {
    path: "/login",
    name: "Login",
    component: LoginView,
  },
  {
    path: "/register",
    name: "Register",
    component: RegisterView,
  },
  {
    path: "/projects",
    name: "Projects",
    component: HomeView,
  },
  {
    path: "/cms",
    name: "CMS",
    component: CmsView,
  },
  {
    path: "/cms/edit/:projectId",
    name: "CMSEdit",
    component: CmsView,
  },
  {
    path: "/p/:projectId/home",
    name: "MeetingWareHome",
    component: ProjectHomeView,
  },
  {
    path: '/p/:projectId/page/:pageIndex',
    name: 'MeetingWarePage',
    component: ProjectPageView
  },
  {
    path: '/p/:projectId/meeting/:meetingId',
    name: 'MeetingWareMeeting',
    component: ProjectMeetingView
  },
  {
    path: '/p/:projectId/kanban',
    name: 'MeetingWareKanban',
    component: ProjectKanban
  },
  {
    path: '/p/:projectId/sprints',
    name: 'MeetingWareSprints',
    component: SprintsView
  },
  {
    path: '/p/:projectId/metricas',
    name: 'MeetingWareMetrics',
    component: MetricsView
  },
  {
    path: '/p/:projectId/login',
    name: 'MeetingWareLogin',
    component: ProjectLoginView
  },
  {
    path: '/p/:projectId/register',
    name: 'MeetingWareRegister',
    component: ProjectRegisterview
  },
  {
    path: '/p/:projectId/chat',
    name: 'MeetingWareChat',
    component: ChatView
  },
  {
    path: '/tutorial',
    name: 'Tutorial',
    component: TutorialView
  },
  {
    path: '/health',
    name: 'Health',
    // Simple component that renders nothing, just for status check
    component: {
      render() {
        return null;
      }
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotfoundView
  }
];

const router = createRouter({
  history: createWebHistory("/"),
  routes,
});

export default router;
